import {captureTokenAuthError, sweetAPI} from 'app/store/sweet-api';
import {APP_SETTINGS_URL} from 'app/urls';

import {AccountSettingsSerializedType} from 'sweet-types';

const SETTINGSTAG = 'settings';

const extendedAPI = sweetAPI
  .enhanceEndpoints({
    addTagTypes: [SETTINGSTAG],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getAccountSettings: build.query<AccountSettingsSerializedType, void>({
        query: () => APP_SETTINGS_URL,
        onQueryStarted: async (args, {queryFulfilled, ...api}) => {
          queryFulfilled.catch((result) => {
            captureTokenAuthError(result.error as any, api, [
              'required-not-in-scope',
            ]);
          });
        },
        providesTags: () => [{type: SETTINGSTAG, id: 'list'}],
      }),
      updateAccountSettings: build.mutation<
        AccountSettingsSerializedType,
        {
          account_id: number;
          company_name?: string;
          company_logo?: string;
          industry_classification?: string;
        }
      >({
        query: ({
          account_id,
          company_name,
          company_logo,
          industry_classification,
        }) => ({
          url: `${APP_SETTINGS_URL}${account_id}/`,
          method: 'PATCH',
          body: {company_name, company_logo, industry_classification},
        }),
        invalidatesTags: () => [{type: SETTINGSTAG, id: 'list'}],
      }),
    }),
  });

// subscribe/fetch - to be used by class components
export const subscribeToAccountSettings =
  extendedAPI.endpoints.getAccountSettings.initiate;

// read cached data - to be used by useSelector / class components
export const accountSettingsSelector =
  extendedAPI.endpoints.getAccountSettings.select();

// https://redux-toolkit.js.org/rtk-query/usage/queries#hook-types
export const {
  useQuery: useAccountSettings,
  useLazyQuery: useLazyAccountSettings,
  useQueryState: useAccountSettingsState,
} = extendedAPI.endpoints.getAccountSettings;

export const {useUpdateAccountSettingsMutation: useUpdateAccountSettings} =
  extendedAPI;
